<script setup>
import {onBeforeMount} from 'vue'

const props = defineProps({
  // 选项
  options: {
    required: true,
    type: Array,
    default: () => []
  },
  // 可选数量
  limit: {
    type: Number,
    default: 2
  },
  labelKey: {
    type: String,
    default: 'storeGroupName'
  },
  valueKey: {
    type: String,
    default: 'storeGroupId'
  },
  // 小标签模式
  smallMode: {
    type: Boolean,
    default: false
  },
  // 已选数量
  selectedCount: {
    required: true,
    type: Number,
    default: 0
  }
})

/*初次加载*/
onBeforeMount(async () => {
  console.log("ytTags onBeforeMount")
  props.options.map(item => {
    item.checked = false
  })
})
const emit = defineEmits(['change'])

/*处理已选中的checkList改变*/
const handleCheckChange = (isCheck, item, index) => {
  props.options.map(option => {
    let resIndex = option.tagList.findIndex(i => i[props.valueKey] === item[props.valueKey])
    if (resIndex !== -1) option.tagList[resIndex].checked = isCheck
  })
  emit("change", props.options)
};
// 处理反显
const handleReview = (reviewList) => {
  console.log("run in handleReview", reviewList)
  let tempList = reviewList.map(item => {
    return item?.[props.valueKey]
  })
  props.options.map(option => {
    option.tagList.map(item => {
      if (tempList.includes(item[props.valueKey])) {
        item.checked = true
      }
    })
  })
}
// 处理删除标签（提供给父组件使用）
const handleRemove = (tagId) => {
  console.log("handleRemove tagId", tagId)
  props.options.map(option => {
    let resIndex = option.tagList.findIndex(i => i.tagId === tagId)
    if (resIndex !== -1) option.tagList[resIndex].checked = false
  })
}
// 处理点击标签，超出限制时的提示
const handleTips = (item) => {
  if (props.selectedCount >= props.limit && !item.checked) ElMessage.error(`当前最多选择${props.limit}个`)
}
// 置空已选项
const handleReset = (list) => {
  props.options.map(tagGroup => {
    tagGroup.tagList.map(tag => {
      tag.checked = false
    })
  })
}

defineExpose({
  handleReview,
  handleRemove,
  handleReset
})
</script>

<template>
  <div :class="props.smallMode ? 'yt_check_tag_default' : 'yt_check_tag_small'" v-for="(item, index) in props.options" :key="`props.options${index}`" @scroll.stop>
    <div class="yt_check_tag_group mg_b_1" v-if="item.tagGroupId !== '0' && item.tagList.length">{{ item.tagGroupName }}</div>
    <div class="yt_check_tag_group mg_b_1" v-if="item.tagGroupId === '0' && props.options.length > 1">其他</div>
    <el-check-tag @click="handleTips(item)" :disabled="selectedCount >= props.limit && !item.checked" class="yt_check_tag" v-for="(item, index) in item.tagList" :key="`checkTag${index}`" :checked="item.checked" type="primary" @change="(isCheck) => handleCheckChange(isCheck, item, index)">
      {{item[labelKey]}}
    </el-check-tag>
  </div>
</template>

<style lang="scss" scoped>
.yt_check_tag_default {
  .yt_check_tag {
    margin-right: 32px;
    line-height: 44px;
    background: #ECECF4;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 0 25px;
    margin-bottom: 15px;
    font-weight: 400;
  }

  .yt_check_tag:last-child {
    margin-right: 0;
  }
  ::v-deep(.el-check-tag) {
    font-size: 16px;
  }
  ::v-deep(.el-check-tag.el-check-tag--primary.is-checked){
    background-color: #796CB4;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
  }
  ::v-deep(.el-check-tag.el-check-tag--primary.is-disabled) {
    background: #ECECF4!important;
    color: #909399!important;
  }
}

.yt_check_tag_group {
  font-weight: 500;
  font-size: 13px;
  color: #000000;
}

/*小标签模式*/
.yt_check_tag_small {
  .yt_check_tag {
    margin-right: 9px;
    line-height: 26px;
    background: #ECECF4;
    border-radius: 13px;
    box-sizing: border-box;
    padding: 0 16px;
    margin-bottom: 15px;
    font-weight: 400;
    font-size: 11px;
    color: #4D4D4D;
  }
  .yt_check_tag:last-child {
    margin-right: 0;
  }
  ::v-deep(.el-check-tag.el-check-tag--primary.is-checked){
    background-color: #F1EBFF;
    font-weight: 500;
    color: #AB89EE;
  }
}
</style>
